<template>
  <div class="main">
    <div class="wrap-particles">
      <div class="main-content">
        <b-navbar style="background-color: #fff;">
          <b-navbar-brand>
            <img src="@/assets/logo.png" style="height:40px;">
          </b-navbar-brand>
        </b-navbar>

        <div class="container py-4 text-center h-75">
          <h1 class="text-white">Mining</h1>

          <div class="row d-flex justify-content-center h-100">
            <form @submit.prevent="create" class="text-white pt-5 w-sm-75 w-md-50 w-lg-25">
              <div class="text-left">
                <div class="form-group">
                  <label>How many teams do you want?</label>
                  <input v-model="teamsN" type="number" pattern="\d*" class="rounded-0 form-control" min="2" max="4">
                </div>
              </div>

              <b-button type="submit" class="mt-auto rounded-0 btn btn-dark text-uppercase">Create game
              </b-button>
            </form>
          </div>
        </div>
      </div>

      <vue-particles color="#ffffff" :particleOpacity="0.3" :particlesNumber="80" shapeType="circle" :particleSize="5"
        :lineLinked="false" :moveSpeed="1" :hoverEffect="false" :clickEffect="false" />
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'createExploration',
  data() {
    return {
      teamsN: null,
    }
  },
  computed: {
    teams() {
      let self = this
      let teamsName = ['andromeda', 'sagittarius', 'hydra', 'triangulum']
      let _teams = {}
      for (let i=0; i<self.teamsN; i++) {
        _teams[teamsName[i]] = {
          name: teamsName[i]
        }
      }
      return _teams
    }
  },
  methods: {
    create: function () {
      let self = this

      let rnd = Math.floor(100000 + Math.random() * 900000)
      firebase.database().ref('games/' + rnd).once('value').then(function (snapshot) {
        let isPinExist = (snapshot.val())
        if (!isPinExist) {
          firebase.database().ref('games/' + rnd).update({
            state: 'waiting',
            pin: rnd,
            mode: 'mining',
            teams: self.teams
          }).then(function () {
            self.$router.replace('/game/' + rnd)
          }).catch(function (err) {
            console.log(err)
          })
          console.log('create')
        } else {
          self.create()
          console.log('recursive')
        }
      })
    }
  }
}
</script>

<style scoped>
.main {
  width: 100vw;
  min-height: 100vh;
  /* overflow: hidden; */
  background-color: #000;
}
</style>
